//
import IsapreTypeModel from "@/models/HumanResource/HrIsapreType"

/**
 * 
 */
const fetchAll = async () => {

    //
    try {

        //
        const response = await IsapreTypeModel.append( appends ).include( includes ).params({ get_all_results: true }).get()

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const appends = [
]

/**
 * 
 */
const includes = [
]

//
export default {
    fetchAll,
}
